<div class="address-location-wrapper">
  <label>
    {{ label }} <span class="required-asterisk" *ngIf="required">*</span>
  </label>
  <div class="address-input-container">
    <input
      #addressInput
      type="text"
      [placeholder]="placeholder"
      [value]="addressValue"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      class="form-control"
      [disabled]="isLoading"
    />
    <div class="loading-indicator" *ngIf="isLoading">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
  </div>
</div>

